<template>
  <el-dialog class="user-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form ref="queryForm" :model="queryParams" label-width="80px" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field inventory-entry fl" label="姓名" prop="customerName">
          <el-input v-model.trim="queryParams.customerName" placeholder="请输入姓名" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item class="search-field inventory-entry fl" label="手机号" prop="phoneNumber">
          <el-input v-model.trim="queryParams.phoneNumber" placeholder="请输入手机号" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <div class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </div>
      </el-form>
      <div class="table-wrap">
        <div class="table-box">
          <auto-height-table instanceHeight="338" ref="spuTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list">
          <el-table-column label="头像" prop="avatar" align="center" min-width="120px">
            <template slot-scope="scope">
              <img @click.stop="mixinHandlePreview(scope.row.avatar)" :src="mixinGetImg(scope.row.avatar)" width="40px"
                height="40px" alt="头像" />
            </template>
          </el-table-column>
            <el-table-column-dict label="姓名" prop="customerName" align="center" min-width="120px" />
            <el-table-column-dict dictType="SEX" label="性别" prop="sex" align="center" min-width="80px" />
            <el-table-column-dict maskType="mobile" label="手机号" prop="phoneNumber" align="center" min-width="120px" />
            <el-table-column-dict :maskStart="3" :maskMiddle="4" :maskEnd="8" label="邮箱" prop="email" align="center" min-width="188px" />
            <el-table-column label="操作" align="center" :width="288 + 'px'" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button size="mini" type="primary"
                @click.native.stop="handleSelect(scope.row)">选择</el-button>
            </template>
          </el-table-column>
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { customerApi } from "@/api"
export default {
  name: "SelectCustomer",
  props: {
    // 客户类型
    customerType: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      //搜索条件参数
      queryParams: {
        noShowCustomerIds: "1", // 不查询id为1的客户
        customerType: "", // 客户类型 1 客户 2 供应商
        customerName: "",
        phoneNumber: "",
        status: "1",
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      total: 0
    }
  },
  watch: {
    customerType: {
      handler: function(val) {
        this.queryParams.customerType = val
        this.getList()
      },
      immediate: true
    }
  },
  methods: {
    handleSelect(row) {
      this.$emit("handleSelect", row)
    },  
    close() {
      this.$emit("close")
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList(options) {
      this.loading = true
      customerApi
        .getList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
